import { Link } from 'react-router-dom';

import { Avatar, Box } from '@mui/material';

import { MRT_ColumnDef } from 'material-react-table';

import { User } from '../../../graphql/API';
import LinkProfile from '../../../pages/Collabs/components/LinkProfile';
import { formatNumber } from '../../../utils/formatter';
import TikTokTag from '../../TikTokTag/TikTokTag';

const base = (hasNoSubscriptionPlan: boolean): MRT_ColumnDef<User>[] => [
  {
    accessorKey: 'picture.medium',
    header: '',
    size: 30,
    enableSorting: false,
    Cell: ({ row }) => (
      <Avatar src={String(row.original.picture?.thumbnail)} alt={row.original.firstname || ''} />
    ),
  },
  {
    accessorKey: 'firstname',
    header: 'Name',
    size: 200,
    enableSorting: true,
    Cell: ({
      row: {
        original: { firstname, lastname, id },
      },
    }) => (
      <LinkProfile
        fontSize='15px'
        url={`/users/${id}`}
        label={`${firstname} ${lastname}`}
        hoverTextDecoration='underline'
        showLink={!hasNoSubscriptionPlan}
      />
    ),
  },
  {
    accessorKey: 'instagramFollowers',
    header: 'IG Followers',
    size: 200,
    enableSorting: true,
    Cell: ({
      row: {
        original: { instagramFollowers },
      },
    }) => formatNumber(instagramFollowers ?? 0),
  },
  {
    accessorKey: 'rating',
    header: 'Rating',
    size: 300,
    enableSorting: true,
    Cell: ({
      row: {
        original: { rating, totalRatings },
      },
    }) => (
      <Box display={'flex'} alignItems={'center'} gap={'4px'}>
        <Box component='span' fontWeight='bold'>
          {rating?.toFixed(1)}
        </Box>
        ({totalRatings} ratings)
      </Box>
    ),
  },
  {
    accessorKey: 'marketName',
    header: 'Market',
    size: 300,
    enableSorting: true,
    Cell: ({
      row: {
        original: { marketName },
      },
    }) => marketName || '-',
  },
  {
    accessorKey: 'totalRequirementsSubmitted',
    header: 'Promotions',
    size: 300,
    enableSorting: true,
    Cell: ({
      row: {
        original: { totalRequirementsSubmitted },
      },
    }) => (
      <Box display={'flex'} alignItems={'center'} gap={'4px'}>
        <Box component='span' fontWeight='bold'>
          {totalRequirementsSubmitted}
        </Box>
      </Box>
    ),
  },
];

export default base;
